package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.model.pages.LeaveReviewUIState
import com.example.mystybag.appCore.model.pages.ReviewCategoryConfigs
import com.example.mystybag.appCore.model.pages.ReviewCouldBeBetterAspect
import com.example.mystybag.communication.common.CommonCommands.createReviewCommand
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_USER_ID
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.sharedmodels.project.database.UserReservationModel
import com.example.mystybag.sharedmodels.project.requestModels.reservations.CreateReviewRequestModel

class LeaveReviewViewModel(
    context: AppContext,
    reservation: UserReservationModel,
    private val onReviewSubmitted: () -> Unit
) : ChildViewModel<LeaveReviewUIState>(
    context,
    LeaveReviewUIState(
        reservation = reservation,
        reviewCategories = ReviewCategoryConfigs.getCategoriesForBusinessCategory(reservation.businessCategoryId)
    )
) {
    init {
        navControls.backButtonVisible = true
    }

    fun onCouldBeBetterChipToggled(aspectId: String) {
        updateState { state ->
            val current = state.selectedCouldBeBetterAspectIds
            val newSet = if (aspectId in current) {
                current - aspectId
            } else if (current.size < ReviewCouldBeBetterAspect.MAX_SELECTION) {
                current + aspectId
            } else {
                current
            }
            state.copy(selectedCouldBeBetterAspectIds = newSet)
        }
    }

    fun onCommentChanged(text: String) {
        updateState {
            it.copy(comment = text.take(200))
        }
    }

    fun onRatingChanged(categoryKey: String, rating: Int) {
        val state = uiState.value
        val categoryIndex = state.reviewCategories.indexOfFirst { it.key == categoryKey }
        if (categoryIndex == -1) return

        updateState {
            when (categoryIndex) {
                0 -> it.copy(ratingCollectionExperience = rating)
                1 -> it.copy(ratingFoodQuality = rating)
                2 -> it.copy(ratingVarietyOfContents = rating)
                3 -> it.copy(ratingFoodQuantity = rating)
                else -> it
            }
        }
    }

    fun onSubmitReviewClick() {
        val state = uiState.value
        if (state.ratingCollectionExperience == 0 ||
            state.ratingFoodQuality == 0 ||
            state.ratingVarietyOfContents == 0 ||
            state.ratingFoodQuantity == 0) {
            return
        }
        submitReview()
    }

    fun onBackClick() {
        goBack(null)
    }

    private fun submitReview() {
        updateState { it.copy(isSubmittingReview = true, isError = false, errorMessage = "") }

        commandBlock(showProgress = false, hideProgress = false) {
            val state = uiState.value
            createReviewCommand(
                CreateReviewRequestModel(
                    userId = Preferences.getLong(PREFERENCES_USER_ID, 0L),
                    reservationId = state.reservation.id,
                    merchantLocationId = state.reservation.merchantLocationId,
                    businessCategoryId = state.reservation.businessCategoryId ?: 0L,
                    ratingCollectionExperience = state.ratingCollectionExperience,
                    ratingFoodQuality = state.ratingFoodQuality,
                    ratingVarietyOfContents = state.ratingVarietyOfContents,
                    ratingFoodQuantity = state.ratingFoodQuantity,
                    couldBeBetterAspects = state.selectedCouldBeBetterAspectIds
                        .mapNotNull { name -> ReviewCouldBeBetterAspect.entries.find { it.name == name }?.ordinal }
                        .take(ReviewCouldBeBetterAspect.MAX_SELECTION)
                        .let { if (it.isEmpty()) null else it },
                    comment = state.comment.trim().take(200).takeIf { it.isNotEmpty() }
                )
            ).onResponse(
                success = {
                    updateState { it.copy(isSubmittingReview = false) }
                    onReviewSubmitted()
                },
                error = { error ->
                    updateState {
                        it.copy(
                            isSubmittingReview = false,
                            isError = true,
                            errorMessage = error.statusMessage ?: "Failed to submit review"
                        )
                    }
                }
            )
        }
    }
}
